import { SurveyName } from './SurveyName';

export type ChartYAxisDomain = {
  min: number;
  max: number;
};

export const SurveyNameToChartYAxisDomainMap: Partial<
  Record<SurveyName, ChartYAxisDomain>
> = {
  [SurveyName.AIMS]: { max: 40, min: 0 },
  [SurveyName.ARFID]: { max: 49, min: 0 },
  [SurveyName.AUDIT]: { max: 40, min: 0 },
  [SurveyName.CET]: { max: 120, min: 0 },
  [SurveyName.C_SSRS_SINCE_LAST_CONTACT]: { max: 5, min: 0 },
  [SurveyName.DUDIT]: { max: 44, min: 0 },
  [SurveyName.EDE_Q]: { max: 6, min: 0 },
  [SurveyName.FNS]: { max: 42, min: 6 },
  [SurveyName.GAD7]: { max: 21, min: 0 },
  [SurveyName.NON_ARFID]: { max: 49, min: 0 },
  [SurveyName.PARDI_ARQ_PARENT]: { max: 6, min: 0 },
  [SurveyName.PARDI_ARQ_SELF]: { max: 6, min: 0 },
  [SurveyName.PCL5]: { max: 80, min: 0 },
  [SurveyName.PHQ8]: { max: 24, min: 0 },
  [SurveyName.PHQ9]: { max: 27, min: 0 },
  [SurveyName.QUALITY_OF_LIFE]: { max: 48, min: 0 },
};
